import styled from 'styled-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon, palette, Typography } from '@dev/ee-components';

const InfoWrapper = styled.div`
    display: flex;
    margin-top 32px;
`;

const IconInfoWrapper = styled.div`
    margin-right: 16px;
    svg {
        fill: ${palette.blue[4]};
        width: 20px;
        height: 20px;
        margin-top: 3px;
    }
`;
export const ContactLimitReachModal = (props: {data:string[]}): JSX.Element => {
    const { t } = useTranslation();
    const { data } = props;

    return (
        <>
            <Typography variant="body1">{t('contactlimitreached_desc', {contactsAlreadyUsed:data[0], contactsLimit:data[1], contactsTryToUpload:data[2]})}</Typography>
            <InfoWrapper>
                <IconInfoWrapper><InfoIcon /></IconInfoWrapper>
                <Typography variant="body1">{t('contactlimitreached_info', {contactsAvailableToUpload: data[3]})}</Typography>
            </InfoWrapper>
        </>
    );
};